import { z } from 'zod';
/**
 * Meus profissionais (G6, estudo de visão de 28/10): os contatos de confiança da pessoa, com o
 * histórico do que fizeram, o preço pago, "chamar de novo" e o lembrete de manutenção. A relação
 * vai para o WhatsApp de propósito; o que fica no Secretário é a memória, do lado de quem paga.
 */
/** Selo do lugar no Perto: pessoas diferentes que chamaram, a partir disto (nada de selo vazio). */
export const PRO_SEAL_MIN = 5;
/** Lembrete de manutenção: de 1 mês a 2 anos. */
export const PRO_REMIND_DAYS = [30, 60, 90, 180, 365, 730];
export const proServiceSchema = z.object({
    at: z.iso.datetime(),
    title: z.string(),
    priceCents: z.number().int().nonnegative().nullable(),
});
export const myProSchema = z.object({
    id: z.uuid(),
    /** Do Perto de Mim, quando veio de lá. */
    placeId: z.string().nullable(),
    name: z.string(),
    /** O que ele faz ("Eletricista", "Diarista"). */
    label: z.string(),
    phone: z.string().nullable(),
    note: z.string().nullable(),
    services: z.number().int(),
    lastServiceAt: z.iso.datetime().nullable(),
    /** Os últimos serviços, do mais novo ao mais antigo. */
    history: z.array(proServiceSchema),
    remindEveryDays: z.number().int().nullable(),
    nextRemindAt: z.iso.datetime().nullable(),
});
export const createMyProSchema = z.object({
    name: z.string().trim().min(1).max(80),
    label: z.string().trim().min(1).max(60),
    phone: z.string().trim().max(32).nullable().optional(),
});
export const updateMyProSchema = z
    .object({
    label: z.string().trim().min(1).max(60).optional(),
    note: z.string().trim().max(400).nullable().optional(),
    remindEveryDays: z
        .number()
        .int()
        .refine((value) => PRO_REMIND_DAYS.includes(value))
        .nullable()
        .optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nada para salvar.' });
export const addProServiceSchema = z.object({
    title: z.string().trim().min(1).max(120),
    at: z.iso.datetime().optional(),
    priceCents: z.number().int().min(0).max(100_000_000).nullable().optional(),
});
/** "Chamar de novo": a mensagem na voz da pessoa, sem nome de tela nem recurso. */
export function proCallAgainText(proName) {
    const first = proName.trim().split(/\s+/)[0] ?? '';
    return `Olá${first ? `, ${first}` : ''}! Tudo bem? Preciso de você de novo. Você tem horário nos próximos dias?`;
}
export const remindLabel = (days) => days < 365
    ? days === 30
        ? 'todo mês'
        : `a cada ${Math.round(days / 30)} meses`
    : days === 365
        ? 'uma vez por ano'
        : 'a cada 2 anos';
